import { Attachment } from './attachment.model';
import { BusinessUser } from './business-user.model'
import { Detail } from './detail.model'
import { User } from './user.model'
import { BasicRegister } from './basic-register.model'
import { Company } from './company.model'
import { ItemDetail } from './item-detail.model'
import { Item } from './item.model'

export class Call {
  id: number;
  number: number;
  identifier: string;
  company_id?: number;
  result_center_id?: number;
  business_id?: number;
  business_user_id: number;
  user_id?: number;
  group_id?: number;
  call_operational_system?: string;
  call_user_agent?: string;
  call_origin?: string;
  media?: string;
  description?: string;
  status?: string;
  type?: string;
  priority?: string;
  is_actived: boolean;
  created_at: string;
  updated_at: string;
  business_user: BusinessUser;
  company: Company;
  result_center?: BasicRegister;
  business?: BasicRegister;
  user: User;
  items: Item[];
  statuses: ItemDetail[];
  notes: ItemDetail[];
  tags: ItemDetail[];
  files: Attachment[];
  // service_orders: [];
  status_detail: Detail;
  type_detail: Detail;
  priority_detail: Detail;
  added_at: string;
  last_movement_at: string;
  user_agent: string;
}
